import "core-js/modules/es.string.link";

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import NavigationItemRecord from '../records/NavigationItemRecord';
import { requestNavigation } from '../store/navigation/actions';
import sendBusinessEvent from '../business-events/business-events';
export default (function (_ref) {
  var dispatch = _ref.dispatch,
      _ref$link = _ref.link,
      navigationUrl = _ref$link.url,
      displayType = _ref$link.type,
      _ref$link$dataAttribu = _ref$link.dataAttributes,
      dataAttributes = _ref$link$dataAttribu === void 0 ? {} : _ref$link$dataAttribu,
      eid = _ref$link.eid;
  eid && sendBusinessEvent(eid);
  dispatch(requestNavigation(new NavigationItemRecord({
    navigationUrl: navigationUrl,
    displayType: displayType,
    deviceFeature: dataAttributes['data-device-feature'],
    anchorTagAttributes: dataAttributes
  })));
});